import React, { Component } from "react";

export const ParameterTab = () => {
  return <div>ParameterGroupTab</div>;
};
